import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import queryString from 'query-string';
import { isEmpty } from 'lodash';

import { getEnergyViewId, getEnergyViewName } from '../Navigation/NavigationHelper';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import PowerGrid from './PowerGrid';
import PowerGraph from './PowerGraph';
import ClientActionMenu from '../Core/Client/ClientActionMenu';
import EnergyViewSelector from '../../../components/EnergyViewSelector';
import BobKpiPanel from '../../../components/BobKpiPanel';
import HeatMap from './HeatMap';
import EquipmentEnergyGrid from './EquipmentEnergyGrid';
import AvoidedCostsGraph from './AvoidedCostsGraph';

import * as DashboardActions from '../../../actions/dashboardActions';
import * as EnergyActions from '../../../actions/energyActions';

import * as classes from './ViewContainer.module.css';
import SiteEnergyGrid from './SiteEnergyGrid';
import FutureSavingsGraph from './FutureSavingsGraph';

const ViewContainer = ({
    activeNavClient,
    activeNavCompany,
    activeNavSite,
    activeNavEquipment,
    bobLoading,
    clientEnergyEquipment,
    clientEnergyKpis,
    clientEnergySites,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    desiredInterval,
    equipmentAvoidedCosts,
    equipmentEnergyData,
    equipmentEnergyKpis,
    equipmentFutureSavings,
    fetchClientEnergyEquipment,
    fetchClientEnergyKpis,
    fetchEnergyEquipment,
    fetchEnergySites,
    fetchEquipmentAvoidedCosts,
    fetchEquipmentEnergyData,
    fetchEquipmentEnergyKpis,
    fetchEquipmentFutureSavings,
    fetchSiteAvoidedCosts,
    fetchSiteEnergyData,
    fetchSiteEnergyKpis,
    fetchSiteFutureSavings,
    history,
    setWorkBookMode,
    siteEnergyData,
    siteEnergyEquipment,
    siteEnergyKpis,
    siteFutureSavings,
    workbookModeEnabled,
    ...props
}) => {
    const [view, setView] = useState();
    const [clientsInitialized, setClientsInitialized] = useState(false);
    const [equipmentInitialized, setEquipmentInitialized] = useState(false);
    const [sitesInitialized, setSitesInitialized] = useState(false);

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        const childId = queryValues.childId;
        const selectedView = getEnergyViewName(childId);
        setView(selectedView);

    }, [queryValues.childId]);

    useEffect(() => {
        const initEquipment = async () => await equipmentInitialization();
        const initSite = async () => await siteInitialization();
        const initClient = async () => await clientInitialization();

        if (!isEmpty(activeNavEquipment) && (view === 'Equipment Power Grid' || view === 'Equipment Power Graph' || view === 'Equipment Heat Map' || view === 'Equipment Avoided Costs Graph' || view === 'Equipment Future Savings Graph') && !equipmentInitialized) {
            initEquipment();
            setEquipmentInitialized(true);
        }

        if (!isEmpty(activeNavSite) && (view === 'Site Power Grid' || view === 'Site Power Graph' || view === 'Site Heat Map' || view === 'Site Equipment Grid' || view === 'Site Avoided Costs Graph' || view === 'Site Future Savings Graph') && !sitesInitialized) {
            initSite();
            setSitesInitialized(true);
        }

        if (!isEmpty(activeNavClient) && (view === 'Client Site Grid' || view === 'Client Equipment Grid')) {
            initClient();
            setClientsInitialized(true);
        }
    }, [view]);

    useEffect(() => {
        const init = async () => {
            if (view === 'Equipment Power Grid' || view === 'Equipment Power Graph' || view === 'Equipment Heat Map' || view === 'Equipment Avoided Costs Graph' || view === 'Equipment Future Savings Graph') {
                await equipmentInitialization();
            } else if (view === 'Site Power Grid' || view === 'Site Power Graph' || view === 'Site Heat Map' || view === 'Site Equipment Grid' || view === 'Site Avoided Costs Graph' || view === 'Site Future Savings Graph') {
                await siteInitialization();
            } else if (view === 'Client Site Grid' || view === 'Client Equipment Grid') {
                await clientInitialization();
            }
        };

        if (!isEmpty(activeNavCompany)) init();
    }, [dashboardStartTimeStamp, dashboardEndTimeStamp]);

    useEffect(() => {
        const init = async () => await equipmentInitialization();

        if (!isEmpty(activeNavEquipment) && (view === 'Equipment Power Grid' || view === 'Equipment Power Graph' || view === 'Equipment Heat Map' || view === 'Equipment Avoided Costs Graph' || view === 'Equipment Future Savings Graph') && !equipmentInitialized) {
            init();
            setEquipmentInitialized(true);
        }
    }, [activeNavEquipment]);

    useEffect(() => {
        const init = async () => await siteInitialization();

        if (!isEmpty(activeNavSite) && (view === 'Site Power Grid' || view === 'Site Power Graph' || view === 'Site Heat Map' || view === 'Site Equipment Grid' || view === 'Site Avoided Costs Graph' || view === 'Site Future Savings Graph') && !sitesInitialized) {
            init();
            setSitesInitialized(true);
        }
    }, [activeNavSite]);

    useEffect(() => {
        const init = async () => await clientInitialization();

        if (!isEmpty(activeNavClient) && (view === 'Client Site Grid' || view === 'Client Equipment Grid') && !clientsInitialized) {
            init();
            setClientsInitialized(true);
        }
    }, [activeNavClient]);

    const clientInitialization = async () => {
        const options = {
            StartDate:        dashboardStartTimeStamp,
            EndDate:          dashboardEndTimeStamp,
            EnergyTabView:    'Site',
            EnergyUnit:       'Watts',
            Interval:         15,
            TimeIntervalUnit: 'minutes',
            AllRecords:       true
        };

        await Promise.all([
            fetchClientEnergyEquipment(activeNavCompany.id, activeNavClient.id, { ...options, EnergyTabView: 'Equipment' }),
            fetchEnergySites(activeNavCompany.id, activeNavClient.id, { ...options }),
            fetchClientEnergyKpis(activeNavClient.id, {...options, EnergyTabView: 'Client'})
        ].map(p => p.catch(err => err)));
    };

    const siteInitialization = async () => {
        const options = {
            StartDate:        dashboardStartTimeStamp,
            EndDate:          dashboardEndTimeStamp,
            EnergyTabView:    'Site',
            EnergyUnit:       'Watts',
            Interval:         15,
            TimeIntervalUnit: 'minutes',
            AllRecords:       true
        };

        await Promise.all([
            //fetchSiteAvoidedCosts(activeNavClient.id, activeNavSite.id, { ...options, EnergyTabView: 'Equipment' }),
            fetchSiteFutureSavings(activeNavClient.id, activeNavSite.id, { ...options, Interval: 1, TimeIntervalUnit: 'days', AllRecords: true }),
            fetchEnergyEquipment(activeNavCompany.id, activeNavClient.id, activeNavSite.id, { ...options, EnergyTabView: 'Equipment' }),
            fetchSiteEnergyData(activeNavClient.id, activeNavSite.id, { ...options }),
            fetchSiteEnergyKpis(activeNavClient.id, activeNavSite.id, { ...options })
        ].map(p => p.catch(err => err)));
    };

    const equipmentInitialization = async () => {
        const options = {
            StartDate:        dashboardStartTimeStamp,
            EndDate:          dashboardEndTimeStamp,
            EnergyTabView:    'Equipment',
            EnergyUnit:       'Watts',
            Interval:         15,
            TimeIntervalUnit: 'minutes',
            AllRecords:       true
        };

        await Promise.all([
            fetchEquipmentFutureSavings(activeNavClient.id, activeNavSite.id, activeNavEquipment.id, { ...options, Interval: 1, TimeIntervalUnit: 'days', AllRecords: true }),
            fetchEquipmentAvoidedCosts(activeNavClient.id, activeNavSite.id, activeNavEquipment.id, { ...options, Interval: 1, TimeIntervalUnit: 'days', EnergyUnit: 'Kilowatts' }),
            fetchEquipmentEnergyData(activeNavClient.id, activeNavSite.id, activeNavEquipment.id, { ...options }),
            fetchEquipmentEnergyKpis(activeNavClient.id, activeNavSite.id, activeNavEquipment.id, { ...options })
        ].map(p => p.catch(err => err)));
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    const refreshGrid = async () => {
        if (view === 'Equipment Power Grid' || view === 'Equipment Power Graph' || view === 'Equipment Heat Map' || view === 'Equipment Avoided Costs Graph' || view === 'Equipment Future Savings Graph') {
            await equipmentInitialization();
        } else if (view === 'Site Power Grid' || view === 'Site Power Graph' || view === 'Site Heat Map' || view === 'Site Equipment Grid' || view === 'Site Avoided Costs Graph' || view === 'Site Future Savings Graph') {
            await siteInitialization();
        } else if (view === 'Client Site Grid' || view === 'Client Equipment Grid') {
            await clientInitialization();
        }
    };

    const handleChangeView = view => {
        const { pathname } = history.location;
        const selectedId = getEnergyViewId(view);
        const queryVals = queryString.parse(history.location.search);
        queryVals.childId = selectedId;

        const queryValuesString = queryString.stringify(queryVals);

        if (selectedId) history.push(`${pathname}?${queryValuesString}`);
        setView(view);
    };

    const roundFunction = (num, decimalPlaces = 0) => {
        num = Math.round(num + 'e' + decimalPlaces);
        return Number(num + 'e' + -decimalPlaces);
    };

    const convertDecimal = (num, decimalPlaces = 0) => {
        num = num * 100;
        num = Math.round(num + 'e' + decimalPlaces);
        return Number(num + 'e' + -decimalPlaces);
    };

    const renderKpiPanel = () => {
        if (view === 'Equipment Power Grid' || view === 'Equipment Power Graph' || view === 'Equipment Heat Map' || view === 'Equipment Avoided Costs Graph' || view === 'Equipment Future Savings Graph') {
            const kpis = { ...equipmentEnergyKpis };

            return (
                <React.Fragment>
                    <BobKpiPanel
                        title={'Energy Usage'}
                        rows={[{ label: 'Total energy use', value: !isEmpty(kpis) ? `${roundFunction(kpis.totalEnergyUse, 3)} kWh` : '-' }, { label: 'Change from prior period', value: !isEmpty(kpis) ? `${convertDecimal(kpis.changeFromPriorPeriod, 2)}%` : '-' }, { label: 'Delta to prior period', value: !isEmpty(kpis) ? roundFunction(kpis.deltaToPriorPeriod, 2) : '-' }]}
                        information="Equipment Energy Use Information"
                    />
                    <BobKpiPanel
                        title={'Energy Cost'}
                        rows={[{ label: 'Total energy cost', value: !isEmpty(kpis) ? `$${roundFunction(kpis.totalEnergyCost, 2)}` : '-' }, { label: 'Change from prior period', value: !isEmpty(kpis) ? `${convertDecimal(kpis.changeFromPriorPeriodCost, 2)}%` : '-' }, { label: 'Delta to prior period', value: !isEmpty(kpis) ? roundFunction(kpis.deltaToPriorPeriodCost, 2) : '-' }]}
                        information="Equipment Energy Cost Information"
                    />
                    <BobKpiPanel
                        title={'CO2 Emissions'}
                        rows={[{ label: 'Total CO2 Emissions', value: !isEmpty(kpis) ? `${roundFunction(kpis.totalEmissionCO2, 2)} lbs` : '-' }, { label: 'Change from prior period', value: !isEmpty(kpis) ? `${convertDecimal(kpis.changeFromPriorPeriodCO2, 2)}%` : '-' }, { label: 'Delta to prior period', value: !isEmpty(kpis) ? roundFunction(kpis.deltaToPriorPeriodCO2, 2) : '-' }]}
                        information="Equipment Emissions Information"
                    />
                </React.Fragment>
            );
        } else if (view === 'Site Power Grid' || view === 'Site Power Graph' || view === 'Site Heat Map' || view === 'Site Equipment Grid' || view === 'Site Avoided Costs Graph' || view === 'Site Future Savings Graph') {
            const kpis = { ...siteEnergyKpis };

            return (
                <React.Fragment>
                    <BobKpiPanel
                        title={'Energy Usage'}
                        rows={[{ label: 'Total energy use', value: !isEmpty(kpis) ? `${roundFunction(kpis.totalEnergyUse, 3)} kWh ` : '-' }, { label: 'Change from prior period', value: !isEmpty(kpis) ? `${convertDecimal(kpis.changeFromPriorPeriod, 2)}%` : '-' }, { label: 'Delta to prior period', value: !isEmpty(kpis) ? roundFunction(kpis.deltaToPriorPeriod, 2) : '-' }]}
                        information="Equipment Energy Usage Information"
                    />
                    <BobKpiPanel
                        title={'Energy Cost'}
                        rows={[{ label: 'Total energy cost', value: !isEmpty(kpis) ? `$${roundFunction(kpis.totalEnergyCost, 2)}` : '-' }, { label: 'Change from prior period', value: !isEmpty(kpis) ? `${convertDecimal(kpis.changeFromPriorPeriodCost, 2)}%` : '-' }, { label: 'Delta to prior period', value: !isEmpty(kpis) ? roundFunction(kpis.deltaToPriorPeriodCost, 2) : '-' }]}
                        information="Equipment Energy Cost Information"
                    />
                    <BobKpiPanel
                        title={'CO2 Emissions'}
                        rows={[{ label: 'Total CO2 Emissions', value: !isEmpty(kpis) ? `${roundFunction(kpis.totalEmissionCO2, 2)} lbs` : '-' }, { label: 'Change from prior period', value: !isEmpty(kpis) ? `${convertDecimal(kpis.changeFromPriorPeriodCO2, 2)}%` : '-' }, { label: 'Delta to prior period', value: !isEmpty(kpis) ? roundFunction(kpis.deltaToPriorPeriodCO2, 2) : '-' }]}
                        information="Equipment Emissions Information"
                    />
                </React.Fragment>
            );
        } else if (view === 'Client Site Grid' || view === 'Client Equipment Grid') {
            const kpis = { ...clientEnergyKpis };

            return (
                <React.Fragment>
                    <BobKpiPanel
                        title={'Energy Usage'}
                        rows={[{ label: 'Total energy use', value: !isEmpty(kpis) ? `${roundFunction(kpis.totalEnergyUse, 3)} kWh ` : '-' }, { label: 'Change from prior period', value: !isEmpty(kpis) ? `${convertDecimal(kpis.changeFromPriorPeriod, 2)}%` : '-' }, { label: 'Delta to prior period', value: !isEmpty(kpis) ? roundFunction(kpis.deltaToPriorPeriod, 2) : '-' }]}
                        information="Equipment Energy Usage Information"
                    />
                    <BobKpiPanel
                        title={'Energy Cost'}
                        rows={[{ label: 'Total energy cost', value: !isEmpty(kpis) ? `$${roundFunction(kpis.totalEnergyCost, 2)}` : '-' }, { label: 'Change from prior period', value: !isEmpty(kpis) ? `${convertDecimal(kpis.changeFromPriorPeriodCost, 2)}%` : '-' }, { label: 'Delta to prior period', value: !isEmpty(kpis) ? roundFunction(kpis.deltaToPriorPeriodCost, 2) : '-' }]}
                        information="Equipment Energy Cost Information"
                    />
                    <BobKpiPanel
                        title={'CO2 Emissions'}
                        rows={[{ label: 'Total CO2 Emissions', value: !isEmpty(kpis) ? `${roundFunction(kpis.totalEmissionCO2, 2)} lbs` : '-' }, { label: 'Change from prior period', value: !isEmpty(kpis) ? `${convertDecimal(kpis.changeFromPriorPeriodCO2, 2)}%` : '-' }, { label: 'Delta to prior period', value: !isEmpty(kpis) ? roundFunction(kpis.deltaToPriorPeriodCO2, 2) : '-' }]}
                        information="Equipment Emissions Information"
                    />
                </React.Fragment>
            );
        }
    };

    return (
        <div className={classes.SiteViewContainer}>
            <div className={classes.KpiContainer}>
                {renderKpiPanel()}
            </div>
            <div className={classes.SelectorContainer}>
                <EnergyViewSelector
                    view={view}
                    handleChangeView={handleChangeView}
                />
            </div>
            <div className={classes.SearchContainer} />
            <div className={classes.TotalsContainer}>
                <BobWorkbookModeButton
                    handleWorkbookMode={handleWorkbookMode}
                    workbookMode={workbookModeEnabled}
                />
            </div>
            <div className={classes.DesiredIntervalContainer}>
                <label className={classes.IntervalLabel}>{`Interval - ${desiredInterval}`}</label>
            </div>
            <div
                className={classes.RefreshContainer}
                aria-hidden="true"
                role="button"
                tabIndex={0}
                onClick={refreshGrid}
            >
                <span className="material-icons-outlined">refresh</span>
            </div>
            <div className={classes.ActionsContainer}>
                <span className={classes.ActionButton}>
                    <ClientActionMenu />
                </span>
            </div>
            <div className={classes.TablePanel}>
                {
                    view === 'Client Site Grid' ?
                        <SiteEnergyGrid
                            data={clientEnergySites}
                            entity="site"
                            hasInitialized={clientsInitialized}
                        />
                        : 
                        null
                }
                {
                    view === 'Client Equipment Grid' ?
                        <EquipmentEnergyGrid
                            data={clientEnergyEquipment}
                            entity="equipment"
                            hasInitialized={clientsInitialized}
                        />
                        :
                        null
                }
                {
                    view === 'Site Heat Map' ?
                        <HeatMap
                            data={siteEnergyData}
                            hasInitialized={sitesInitialized}
                        />
                        :
                        null
                }
                {
                    view === 'Site Power Grid' ?
                        <PowerGrid
                            data={siteEnergyData}
                            hasInitialized={sitesInitialized}
                            entity="site"
                        />
                        :
                        null
                }
                {
                    view === 'Site Power Graph' ?
                        <PowerGraph
                            data={siteEnergyData}
                            hasInitialized={sitesInitialized}
                        />
                        :
                        null
                }
                {
                    view === 'Site Equipment Grid' ?
                        <EquipmentEnergyGrid
                            data={siteEnergyEquipment}
                            entity="equipment"
                            hasInitialized={sitesInitialized}
                        />
                        :
                        null
                }
                {
                    view === 'Site Avoided Costs Graph' ?
                        <AvoidedCostsGraph
                            data={[]}
                            hasInitialized={sitesInitialized}
                        />
                        :
                        null
                }
                {
                    view === 'Site Future Savings Graph' ?
                        <FutureSavingsGraph
                            data={siteFutureSavings}
                            hasInitialized={sitesInitialized}
                        />
                        :
                        null
                }
                {
                    view === 'Equipment Heat Map' ?
                        <HeatMap
                            data={equipmentEnergyData}
                            hasInitialized={equipmentInitialized}
                        />
                        :
                        null
                }
                {
                    view === 'Equipment Power Grid' ?
                        <PowerGrid
                            data={equipmentEnergyData}
                            hasInitialized={equipmentInitialized}
                            entity="equipment"
                        />
                        :
                        null
                }
                {
                    view === 'Equipment Power Graph' ?
                        <PowerGraph
                            data={equipmentEnergyData}
                            hasInitialized={equipmentInitialized}
                        />
                        :
                        null
                }
                {
                    view === 'Equipment Avoided Costs Graph' ?
                        <AvoidedCostsGraph
                            data={equipmentAvoidedCosts}
                            hasInitialized={equipmentInitialized}
                        />
                        :
                        null
                }
                {
                    view === 'Equipment Future Savings Graph' ?
                        <FutureSavingsGraph
                            data={equipmentFutureSavings}
                            hasInitialized={equipmentInitialized}
                        />
                        :
                        null
                }
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:            state.bob.activeNavCompany,
        activeNavClient:             state.bob.activeNavClient,
        activeNavSite:               state.bob.activeNavSite,
        activeNavEquipment:          state.bob.activeNavEquipment,
        bobLoading:                  state.bob.bobLoading,
        dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
        desiredInterval:             state.dashboard.desiredInterval,
        clientEnergyEquipment:       state.energy.clientEnergyEquipment,
        clientEnergyKpis:            state.energy.clientEnergyKpis,
        clientEnergySites:           state.energy.clientEnergySites,
        equipmentAvoidedCosts:       state.energy.equipmentAvoidedCosts,
        equipmentEnergyData:         state.energy.equipmentEnergyData,
        equipmentEnergyKpis:         state.energy.equipmentEnergyKpis,
        equipmentFutureSavings:      state.energy.equipmentFutureSavings,
        siteEnergyData:              state.energy.siteEnergyData,
        siteEnergyEquipment:         state.energy.siteEnergyEquipment,
        siteEnergyKpis:              state.energy.siteEnergyKpis,
        siteFutureSavings:           state.energy.siteFutureSavings,
        workbookModeEnabled:         state.dashboard.workbookModeEnabled,
    };
};


const mapDispatchToProps = {
    ...DashboardActions,
    ...EnergyActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewContainer));
